var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex m-3 mt-4"},[_c('ion-icon',{attrs:{"name":"folder-outline"}}),_c('h5',{staticClass:"font-weight-bold text-dark mx-2"},[_vm._v(" صور ذات صلة ")])],1),(_vm.loader && _vm.itemsData.length !=0)?_c('div',[_c('VueJustifiedLayout',{attrs:{"items":_vm.itemsData,"options":{
  containerPadding: 10,
  forceAspectRatio: 0,
  fullWidthBreakoutRowCadence:0,
  showWidows: false,
  targetRowHeight:200,
  boxSpacing:3

}},scopedSlots:_vm._u([{key:"default",fn:function({ item, index }){return [_c('router-link',{staticClass:"cursor-pointer close",attrs:{"data-dismiss":"modal","aria-label":"Close","to":{
            name: 'details',
            params: { id: item.id },
            query: {
              image: item.image,
              height: item.height,
              width: item.width,
              pres: (item.height / item.width) * 100,
            },
          }}},[_c('img',{staticClass:"animate__animated animate__fadeIn",style:(`animation-delay:.${index}s`),attrs:{"src":'https://pic.imamhussain.org/photos/preview/' + item.image,"width":"100%","alt":item.image},on:{"click":_vm.scrollToTop}})])]}}],null,false,1058892197)}),_c('div',{staticClass:"row pb-5 justify-content-center animate__animated animate__fadeInUp my-3"},[(_vm.items.next_page_url !=null)?_c('vs-button',{staticClass:"mb-5",attrs:{"color":"rgb(211, 186, 127)","flat":"","gradient":"","loading":_vm.loading,"size":"large"},on:{"click":_vm.loadMore}},[_vm._v(" تحميل المزيد ")]):_vm._e()],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }